module.exports = __webpack_public_path__ + "img/icon_central.33852086.svg";